import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Application } from '@modules/common/types/application';
import { VirtualFolder } from '@modules/notes/types/virtual-folder';
import { AdvancedSearchService } from '@modules/search/services/advanced-search.service';

@Component({
  selector: 'app-notes-list-context-menu',
  templateUrl: './notes-context-menu.component.html',
  styleUrls: ['./notes-context-menu.component.less'],
  standalone: false,
})
export class NotesContextMenuComponent {
  // Input
  @Input() filterKey: VirtualFolder;

  // Outputs
  @Output() change = new EventEmitter<VirtualFolder>();

  protected readonly searchService = inject(AdvancedSearchService);
  protected readonly isAdvancedSearchApplied = toSignal(this.searchService.isAdvancedSearchApplied(Application.notes), {
    initialValue: false,
  });

  /**
   * Actions
   */

  selectFilter(filter: VirtualFolder) {
    this.change.emit(filter);
  }
}
